import React from "react";
import Select from "react-select";

const CustomDropdownMultiple = ({
  fieldName,
  error,
  values,
  label,
  classes,
  setFieldValue,
  options,
  handleChange,
  allowStyle = true
}) => {
  return (
    <div
      className={`form-group ${classes ? classes : ""} mb-3 ${error ? "is-invalid" : "is-valid"
        }`}
    >
      <label className="text-label">{label}</label>
      <Select
        isMulti
        closeMenuOnSelect={false}
        value={values}
        onChange={(selectedOption) => {
          if (setFieldValue) {
            setFieldValue(
              fieldName,
              selectedOption ? selectedOption.map((opt) => opt.value) : []
            );
          }
          if (handleChange) {
            handleChange(selectedOption);
          }
        }}
        onBlur={() => setFieldValue ? setFieldValue(`touched.${fieldName}`, true) : null}
        options={options}
        name={fieldName}
        style={{
          lineHeight: "40px",
          color: "#7e7e7e",
          paddingLeft: " 15px",
        }}
        classNames={{
          control: (state) => allowStyle ? "form-control p-0 select-custom-css" : "", // add your class here
        }}
      />

      {error && (
        <div
          id={`val-${fieldName}-error`}
          class="invalid-feedback animated fadeInUp"
          style={{ display: "block" }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default CustomDropdownMultiple;
